export const DEFAULT_ERROR_MESSAGE = "Something went wrong.";
export const DEFAULT_SUGGESTION_MESSAGE = " Please try again later.";

export const DEFAULT_ERROR_WITH_SUGGESTION_MESSAGE = `${DEFAULT_ERROR_MESSAGE}${DEFAULT_SUGGESTION_MESSAGE}`;

export const IN_DEVELOPMENT = "companies:list:view"; //this permission is temporal until feature is approved for all users

export const NA_MESSAGE = "N.A.";

export const PERCENTAGE_MESSAGE = "\u00A0(%)";
